import React, { Component } from "react";
import { ButtonToolbar, Table, Grid } from 'react-bootstrap';

import { PropTypes } from 'prop-types';
import { LoadingSpinner } from '../../LoadingSpinner';
import { SortIndicator } from '../../SortIndicator';
import { PaginationBuilder } from '../../PaginationBuilder';
import { TableButton } from '../../TableButton';
import { SearchHelper } from '../../helpers/SearchHelper';
import { PaginationHelper } from '../../helpers/PaginationHelper';

export class StopsDraft extends Component {
    static contextTypes = {
        edition: PropTypes.object
    }

    constructor(props) {
        super(props);

        this.state = {
            render: {
                sort: {
                    property: "code",
                    type: "ascending"
                }
            }
        }
    }

    // -----------------------

    getStopLines(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopLines(stop);
            stop.lines = [];
        }
    }

    getStopMunicipality(stops) {
        const stop = stops.find(s => s.lines === undefined);

        if (undefined !== stop) {
            this.props.getStopMunicipality(stop);
            stop.municipality = [];
        }
    }

    // -----------------------

    onChangeSort(property) {
        const { render } = this.state;

        render.sort.type = render.sort.property === property && "ascending" === render.sort.type ? "descending" : "ascending";
        render.sort.property = property;

        this.setState({
            render: render
        });
    }

    // -----------------------

    filterByInfo(value) {
        return value.map(v => v).join();
    }

    sortStops(sort, a, b) {
        let aValue = a[sort.property];
        let bValue = b[sort.property];

        if ("object" === typeof aValue) {
            aValue = undefined !== aValue.left ? aValue.left : aValue.right;
        }

        if ("object" === typeof bValue) {
            bValue = undefined !== bValue.left ? bValue.left : bValue.right;
        }

        if(undefined === aValue) {
            aValue = "";
        }

        if(undefined === bValue) {
            bValue = "";
        }

        if (aValue === bValue) {
            return 0;
        }

        const output = aValue < bValue ? -1 : 1;

        if ("descending" === sort.type) {
            return output * -1;
        }

        return output;
    }

    // -----------------------

    renderLoading(isLoading) {
        if (isLoading) {
            return (
                <LoadingSpinner />
            );
        }

        return null;
    }

    renderSortIndicator(property, sort) {
        if (property !== sort.property) {
            return (
                <SortIndicator order="none" />
            );
        }

        return (
            <SortIndicator order={sort.type} />
        );
    }

    render() {
        const { edition } = this.context;

        if (null === edition || undefined === edition) {
            return null;
        }

        const { render } = this.state;
        const { stops, isLoading, currentPage, elementsPerPage, filter } = this.props;

        const stopsFiltered = SearchHelper.search({
            filter: filter,
            data: stops,
            fields: ["code", "name", "shortName", "externalCode", "latitude", "longitude", "mapPoint.name", "info"],
            callbackComparison: [{ "info": (a) => this.filterByInfo(a) }]
        });

        const totalPages = PaginationHelper.getTotalPages(stopsFiltered.length, elementsPerPage);
        const activePage = totalPages < currentPage ? totalPages : currentPage;
        const stopsToRender = stopsFiltered.sort((a, b) => this.sortStops(render.sort, a, b))
            .slice((activePage - 1) * elementsPerPage, activePage * elementsPerPage);

        this.getStopLines(stopsToRender);
        this.getStopMunicipality(stopsToRender);

        return (
            <Grid fluid className="table-small-screens">
                <div className="table-loading">
                    <Table responsive striped hover >
                        <thead>
                            <tr>
                                <th className="width-7p sortable" onClick={() => this.onChangeSort("code")}>Código {this.renderSortIndicator("code", render.sort)}</th>
                                <th className="width-11p sortable" onClick={() => this.onChangeSort("externalCode")}>Código Externo {this.renderSortIndicator("externalCode", render.sort)}</th>
                                <th className="width-15p sortable" onClick={() => this.onChangeSort("name")}>Nome {this.renderSortIndicator("name", render.sort)}</th>
                                <th className="width-10p sortable" onClick={() => this.onChangeSort("shortName")}>Abreviatura {this.renderSortIndicator("shortName", render.sort)}</th>
                                <th className="width-8p sortable" onClick={() => this.onChangeSort("latitude")}>Latitude {this.renderSortIndicator("latitude", render.sort)}</th>
                                <th className="width-8p sortable" onClick={() => this.onChangeSort("longitude")}>Longitude {this.renderSortIndicator("longitude", render.sort)}</th>
                                <th className="width-8p">Ponto Notável</th>
                                <th className="width-7p">Mun.</th>
                                <th className="width-8p">Info. Adicional</th>
                                <th className="width-5p">Linhas</th>
                                <th className="width-7p">&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody className={isLoading ? "overlay" : ""}>
                            {
                                stopsToRender.map((stop, idx) =>
                                    <tr key={`stop-${idx}`}>
                                        <td>{stop.code}</td>
                                        <td>{stop.externalCode}</td>
                                        <td>{stop.name}</td>
                                        <td>{stop.shortName}</td>
                                        <td>{stop.latitude}</td>
                                        <td>{stop.longitude}</td>
                                        <td>{undefined !== stop.mapPoint ? stop.mapPoint.name : ''}</td>
                                        <td>{stop.municipality}</td>
                                        <td>{stop.info.map((info, i) => <li key={`stop-${idx}-info-${i}`}>{info}</li>)}</td>
                                        <td>{stop.lines !== undefined ? stop.lines.map((line, i) => <li key={`stop-${idx}-line-${i}`}>{line}</li>) : null}</td>
                                        <td>
                                            <ButtonToolbar className="pull-right">
                                                <TableButton marginRight icon="icon-edit" title="Editar" onClick={() => this.props.onEditClick(stop)} />
                                                <TableButton icon="icon-trash" title="Eliminar" onClick={() => this.props.onDeleteClick(stop)} />
                                            </ButtonToolbar>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                    <PaginationBuilder
                        currentPage={currentPage}
                        elementsPerPage={elementsPerPage}
                        dataLength={stopsFiltered.length}
                        onChangePage={(a) => this.props.onChangePage(a)}
                        onChangeElementsPerPage={(a) => this.props.onChangeElementsPerPage(a)} />

                    {this.renderLoading(isLoading)}
                </div>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/stops/StopsDraft.js